module.exports = __webpack_public_path__ + "static/media/approach-lived-in.0698f0cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/approach-lived-in.jpg
// module id = 139
// module chunks = 0